











































































































import attendTotalDialog from "./attendTotalDialog.vue";
import performanceTotalDialog from "./performanceTotalDialog.vue";
import { getSalarySettingListApi } from "@/api/salary";
import { mixin } from "@/mixin/tabPageInfoMixin";
import { Vue, Component, Mixins } from "vue-property-decorator";
@Component({
  name: "staffSalary",
  components: {
    attendTotalDialog,
    performanceTotalDialog,
  },
})
export default class extends Mixins(mixin) {
  searchInfo: any = {
    key_word: "",
    is_teach: -1,
    performance: -1,
  };
  tableData: any[] = [];
  salaryItems: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  created() {
    this.mixinGetPageInfo("salaryStaffList");
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: any = {
      page: params.page,
      page_size: params.page_size,
    };
    if (this.searchInfo.key_word) {
      option.key_word = this.searchInfo.key_word;
    }
    if (this.searchInfo.is_teach >= 0) {
      option.is_teach = this.searchInfo.is_teach;
    }
    if (this.searchInfo.performance >= 0) {
      option.performance = this.searchInfo.performance;
    }
    getSalarySettingListApi(option).then((res: any) => {
      if (res.error_code === 0) {
        this.tableData = res.data.list;
        if (res.data.list[0]) {
          this.salaryItems = res.data.list[0].salary_items;
        }
        res.data.list.map((item: any) => {
          item.salary_items.map((it: any, idx: number) => {
            item[`salary_items${idx}`] =
              (it.type === 2 ? "- " : "") + it.salary_item_value;
          });
        });
        this.total = res.data.total;
        this.page = res.data.page;
      }
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  toDetail(row: any) {
    this.mixinSavePageInfo("salaryStaffList");
    this.$router.push({
      name: "staffSalaryDetail",
      query: {
        staff_id: row.staff_id,
      },
    });
  }
}
